import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

export const TabTitle = ({faIcon, title}) => (
  <>
    <FontAwesomeIcon icon={faIcon} style={{marginRight: 10}}/>
    {title}
  </>
);
